import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ spacing }) => ({
  container: {
    padding: spacing(6, 7)
  },
  errorMessage: {
    color: "#962B2B",
    fontSize: "0.75rem"
  }
}))
